import { useAuditsDispatch } from './audits-context';
import PortalAppService from '../../../application/platform/portal-app-service';
import { IListAuditsRequest } from '../../../model/base/request/list-audits-request';

export function useAuditsController() {
  const dispatch = useAuditsDispatch();

  const loadAudits = async (params: IListAuditsRequest) => {
    dispatch({ type: 'LOAD_START' });
    try {
      const response = await PortalAppService.requestAudits(params);
      dispatch({ type: 'LOAD_SUCCESS', payload: response });
    } catch (error) {
      dispatch({ type: 'LOAD_ERROR', payload: 'Erro ao carregar auditorias.' });
    }
  };

  return { loadAudits };
}
